import { tryOnUnmounted, until } from '@vueuse/core';
import interfaceStore from 'store/interface';
import { SplitText /*, GSDevTools*/ } from "vendors/gsap";
import { toRef } from 'vue';


/** auto nice clear splitTextInstance
 * - 1st resize or unmounted
 * - fail if no instance
*/
export function cleanSplitTextOnResize(instance:SplitText):Promise<any>{
  if(!instance) return Promise.reject('[helpers/anim] cleanSplitTextOnResize - no instance')
  return Promise.race([
    until(toRef(interfaceStore, 'viewport')).changed(),
    new Promise(resolve=>tryOnUnmounted(()=>resolve(undefined)))
    .then(()=>{
      console.debug('[helpers/anim] cleanSplitTextOnResize onUnmounted')
      return undefined
    }) // @todo does that really work ?
  ])
  .then(()=> instance?.revert() )
}
